import { useFormyContext } from '@givebacks/formy';
import { DevTools } from 'jotai-devtools';
import { ButtonMantine, Code, Container, Group, Stack, Title } from 'ui';
import { useDisclosure } from 'ui/Hooks';

import { useFormListValidation } from './useListValidator';
import { FormListValidatorProvider } from './validation.provider';

const ValidationDebuggerValues = () => {
  const { useGetForms } = useFormListValidation();
  const forms = useGetForms();
  return (
    <Code block mt={5}>
      {JSON.stringify(forms, null, 2)}
    </Code>
  );
};
const ValidationDebugger = () => {
  const [showValues, showValuesHandler] = useDisclosure(false);
  const { resetForms, validateForms } = useFormListValidation();

  return (
    <Container>
      <Title order={3}>Validation Debugger</Title>
      <Stack>
        <Group>
          <ButtonMantine onClick={resetForms}>Reset Forms</ButtonMantine>
          <ButtonMantine onClick={() => validateForms()}>Validate forms</ButtonMantine>
          <ButtonMantine onClick={showValuesHandler.toggle}>
            {showValues ? 'Hide' : 'Show'} Form Values
          </ButtonMantine>
        </Group>
        <Group>{showValues && <ValidationDebuggerValues />}</Group>
      </Stack>
    </Container>
  );
};

const FormListChild = () => {
  const { store } = useFormyContext();
  return <DevTools store={store} />;
};
// If you really need an additional wrapper around something, you can use this
const FormListProviderWrapper = ({
  children,
}: {
  children: React.ReactNode | React.ReactNode[];
}) => {
  return (
    <FormListValidatorProvider>
      {children}
      <FormListChild />
    </FormListValidatorProvider>
  );
};

export { FormListProviderWrapper, ValidationDebugger };
